'use strict';

import angular from 'angular';
import EditController from './edit.controller';

export default angular.module('updateServerApp.writetpl.edit', [])
  .controller('WriteTplEditController', EditController)
  .name;



// WEBPACK FOOTER //
// ./client/app/writeTpl/edit/index.js